export let environment: { apiUrl: string; production: boolean };
environment = {
	production: false,
	apiUrl: 'http://localhost:8888/greenviet-phase2/laravel/public'
	// apiUrl: 'https://greenviet.cuortech.com'

	// apiUrl: 'https://greenviet.azurewebsites.net'
	// apiUrl: 'http://chetsapp.de:8899'
};
